import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  propertiesByProject: [],
  propertiesByProjectCount: 0,
};

const propertiesSlice = createSlice({
  name: "properties",
  initialState,
  reducers: {
    saveListPropertiesByProject: (state, action) => {
      state.propertiesByProject = action.payload;
    },
    saveCountPropertiesByProject: (state, action) => {
      state.propertiesByProjectCount = action.payload;
    },
    clearPropertiesByProject: (state) => {
      state.propertiesByProject = [];
      state.propertiesByProjectCount = 0;
    },
  },
});

export const {
  saveListPropertiesByProject,
  saveCountPropertiesByProject,
  clearPropertiesByProject,
} = propertiesSlice.actions;

export default propertiesSlice.reducer;
